import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["includeKeywordsInput", "alsoIncludeKeywordsInput", "excludeKeywordsInput", "queryInput"]

  connect() {
    this.updatedByUser = false

    if (this.queryInputTarget.value == "") {
      this.update()
    }
  }

  userInputDetected(event) {
    event.target.value == this.convertedQuery() ? this.updatedByUser = false : this.updatedByUser = true
  }

  convertedQuery() {
    const includeKeywords = this.selectedValues(this.includeKeywordsInputTarget)
    const alsoIncludeKeywords = this.hasAlsoIncludeKeywordsInputTarget ? this.selectedValues(this.alsoIncludeKeywordsInputTarget) : []
    const excludeKeywords = this.selectedValues(this.excludeKeywordsInputTarget)

    let includeQuery = ""
    let alsoIncludeQuery = ""
    let excludeQuery = ""

    if (includeKeywords.length > 0) {
      includeQuery = this.convertKeywordsToQuery(includeKeywords).join(" OR ")
      // wrap in parens if there are other keywords
      if (excludeKeywords.length > 0 || alsoIncludeKeywords.length > 0) {
        includeQuery = `(${includeQuery})`
      }
    }

    if (alsoIncludeKeywords.length > 0) {
      alsoIncludeQuery = this.convertKeywordsToQuery(alsoIncludeKeywords).join(" AND ")
      // wrap in parens if there are other keywords
      if (excludeKeywords.length > 0) {
        alsoIncludeQuery = `(${alsoIncludeQuery})`
      }
    }

    if (excludeKeywords.length > 0) {
      excludeQuery = `NOT (${this.convertKeywordsToQuery(excludeKeywords).join(" OR ")})`
    }

    return [includeQuery, alsoIncludeQuery, excludeQuery].filter(query => query.length > 0).join(" AND ")
  }

  convertKeywordsToQuery(keywords) {
    return keywords.map((keyword) => {
      return keyword.trim()
    }).map((keyword) => {
      if (this.isExactQuery(keyword)) {
        return keyword
      } else if (this.isBooleanQuery(keyword) && keywords.length > 1) {
        return `(${keyword})`
      } else if (this.isMultiWordQuery(keyword)) {
        return `"${keyword}"`
      } else {
        return keyword
      }
    })
  }


  isBooleanQuery(query) {
    return query.includes(" OR ") || query.includes(" AND ") || query.includes(" NOT ")
  }

  isExactQuery(query) {
    // query is exact if it is wrapped in quotes
    return query.startsWith('"') && query.endsWith('"')
  }

  isMultiWordQuery(query) {
    if (this.isBooleanQuery(query) || this.isExactQuery(query)) {
      return false
    } else {
      return query.includes(" ")
    }
  }

  update() {
    // Return if the user has provided a custom query
    if (this.updatedByUser) {
      return
    }

    this.queryInputTarget.value = this.convertedQuery()
  }

  selectedValues(selectInput) {
    return Array.from(selectInput.selectedOptions).map(option => option.value)
  }
}
